import React, { useState } from 'react';
import {
  Button,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';

function AccountFilter({ onFilter, userOnly }) {
  const [email, setEmail] = useState('');
  const [lastName, setLastName] = useState('');
  const [role, setRole] = useState('');

  const handleFilter = () => {
    onFilter({ email, lastName, role });
  };

  const resetFilter = () => {
    setEmail('');
    setLastName('');
    setRole('');
    handleFilter();
  };

  return (
    <Box display="flex" gap="10px" marginBottom="20px" flexWrap="wrap">
      <input type="hidden" autoComplete="false" />

      <TextField
        label="Last Name"
        variant="outlined"
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
        sx={{ width: 1 / 5, minWidth: 150 }}
      />
      <TextField
        label="Email"
        variant="outlined"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        sx={{ width: 1 / 5, minWidth: 150 }}
      />
      <FormControl sx={{ width: 1 / 5, minWidth: 150 }}>
        <InputLabel>Role</InputLabel>
        <Select
          value={role}
          label="Role"
          onChange={(e) => setRole(e.target.value)}
        >
          <MenuItem value="">-</MenuItem>
          {/* {!userOnly && <MenuItem value="superadmin">Superadmin</MenuItem>} */}
          {!userOnly && <MenuItem value="admin">Admin</MenuItem>}
          <MenuItem value="staff">Staff</MenuItem>
          <MenuItem value="user">User</MenuItem>
          <MenuItem value="resident">Resident</MenuItem>
        </Select>
      </FormControl>
      <Button variant="contained" onClick={handleFilter}>
        Filter
      </Button>
      <Button variant="contained" onClick={resetFilter} color="error">
        Clear
      </Button>
    </Box>
  );
}

AccountFilter.propTypes = {
  onFilter: PropTypes.func.isRequired,
  userOnly: PropTypes.bool,
};

export default AccountFilter;
